module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "modal"
    }
  }, [_c('div', {
    staticClass: "modal-mask"
  }, [_c('div', {
    staticClass: "modal-wrapper"
  }, [_c('div', {
    staticClass: "modal-container-wrapper"
  }, [_c('div', {
    staticClass: "modal-condcontainer"
  }, [_c('div', {
    staticClass: "modal-window-tab-mark"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-close-button",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "alt": "סגור",
      "src": "images/x.png"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-wndow-content"
  }, [_c('div', {
    staticClass: "modal-wndow-content-title"
  }, [_c('h3', [_vm._v("תנאי סף להצטרפות להרכב רית'ם")])]), _vm._v(" "), _c('div', {
    staticClass: "login-info"
  }, [_c('p', [_vm._v("\nהפרמטרים המפורטים פה הם המינימום הנדרש - נשמח מאוד כמובן לראות הרבה יותר מזה, אבל אם אתם יחסית מתחילים - זה מה שאתם צריכים להיות מסוגלים לעשות:\n")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("\nשירה:\n")]), _vm._v("\n פגיעה בצליל ומודעות לטעויות כשיש, ביצוע רתמי ברמה סבירה, יכולת הפקת צליל בעצמה מתאימה להרכב (חזקה יחסית) והכרת העבודה עם מיקרופון.\n"), _c('br'), _vm._v("\nזמרים שרוצים לשיר בהרכב צריכים להיות בעלי ניסיון שירה משמעותי בהרכב רית'ם (תופים, גיטרות וכו') ו/או אחרי לימוד פיתוח קול לפחות במשך שנה שמכוון למקום הזה. \n"), _c('br'), _vm._v("\nהרשמת זמרים להרכב רית'ם תתבצע לאחר שיחת ייעוץ טלפונית עם המשרד בלבד.\n")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("\nגיטרה/קלידים/בס:\n")]), _vm._v("\n הכרה בסיסית של הכל ותפעול שלו, יכולת לזהות ולנגן את כל האקורדים הבסיסיים בהפקת צליל סבירה, החזקת קצב והבנה קצבית סבירה, מודעות לטעויות.\n")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("\nתופים:\n")]), _vm._v("\n החזקת קצב סבירה, התמצאות בסיסית והבנת מבנה של שיר, נגינה בבאלאנס סביר בסט ומודעות לטעויות.\n")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("\nכלי נשיפה:\n")]), _vm._v("\n הפקת צליל מדויקת ובעצמה מתאימה להרכב, יכולת לקרוא תפקיד בסיסי/לשמוע תפקיד ולהוציא אותו משמיעה, מוסיקליות ומודעות לטעויות.\n")]), _vm._v(" "), _c('p', [_c('u', [_vm._v("\nלכולם:\n")]), _vm._v("\n אין הכרח לדעת תווים.\n")])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-bottom-image"
  }, [_c('img', {
    staticClass: "fillImg",
    attrs: {
      "src": "images/logo.png",
      "alt": "החצר"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2716b0c3!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Conditions.vue
// module id = 108
// module chunks = 0